import { useMatch } from 'react-router-dom';

export const useRouteMatch = () => {
    const root = useMatch('/');

    const campaignRoot = useMatch('/campaigns');
    const campaignEdit = useMatch('/campaigns/edit/:id');
    const campaignList = useMatch('/campaigns/list/:campaignStatus');
    const campaignStatistics = useMatch('/campaigns/statistics/:filter');
    const campaignStatisticsDetails = useMatch('/campaigns/statistics/details/:id');
    const campaignCreateAuto = useMatch('/campaigns/create/auto');
    const campaignPromotionBonuses = useMatch('/campaigns/promotions/:type?/:promotionsStatus?');

    const dialogs = useMatch('/support/dialogs');
    const dialog = useMatch('/support/dialogs/:id');

    const campaigns = useMatch({
        path: '/campaigns',
        end : false
    });
    const media = useMatch({
        path: '/media',
        end : false
    });
    const brandzone = useMatch({
        path: '/bz',
        end : false
    });
    const myShop = useMatch({
        path: '/bs',
        end : false
    });

    return {
        match: {
            root,
            campaigns: {
                root             : campaignRoot,
                edit             : campaignEdit,
                list             : campaignList,
                statistics       : campaignStatistics,
                statisticsDetails: campaignStatisticsDetails,
                createAuto       : campaignCreateAuto,
                promotions       : campaignPromotionBonuses
            },
            dialog: {
                list   : dialogs,
                details: dialog
            },
            groups: {
                campaigns,
                media,
                brandzone,
                myShop
            }

        }
    };
};
